// Importing necessary libraries and components
import React from "react";
// Node.js library to set properties for components
import PropTypes from "prop-types";
// Material-UI core components
import { makeStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";

// Custom styles for the GridItem component
const styles = {
  grid: {
    padding: "0 15px !important", // Adds custom padding to the grid item
  },
};

// Hook to apply custom styles
const useStyles = makeStyles(styles);

// GridItem component definition
export default function GridItem(props) {
  const classes = useStyles(); // Applying custom styles
  const { children, ...rest } = props; // Destructuring props to extract children and other properties

  return (
    // Material-UI Grid item with custom styles and additional props
    <Grid item {...rest} className={classes.grid}>
      {children}
{" "}
{/* Rendering child components */}
    </Grid>
  );
}

// Prop types for the GridItem component
GridItem.propTypes = {
  children: PropTypes.node, // Children can be any valid React node
};
